
import { ICheckInOutIn } from "../../models/input/generalApi/ICheckInOutIn";
import * as ApiWithToken from "../callApiWithToken";

const checkInOutService = {
    getComments: async function (subregionId: number, languageId: number, commentType: string) {
        return ApiWithToken.getApi(process.env.REACT_APP_GENERAL_API + `CheckInOut/GetComments?SubRegionID=${subregionId}&LanguageID=${languageId}&CommentType=${commentType}`);
    },
    postCheckInOut: async function (checkInOut: ICheckInOutIn) {
        return ApiWithToken.postApi(process.env.REACT_APP_GENERAL_API + `CheckInOut/CheckInOutInsert`, checkInOut);
    },
}
export default checkInOutService;
